<div class="wrapper-page invitations-page">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>

  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <span class="header-text">Pozivnice</span>
    </div>

    <div class="invitations-dashboard">
      <div class="invitations-filters">
        <div class="filter-group">
          <span class="filter-title">Pol</span>
          <div class="filter-options">
            <button
              *ngFor="let gender of genderOptions"
              type="button"
              class="filter-option"
              [ngClass]="{'active': activeGender === gender.value}"
              (click)="changeGender(gender.value)"
            >
              <span class="radio-indicator"></span>
              <span>{{gender.label}}</span>
            </button>
          </div>
        </div>

        <div class="filter-group filter-group-age">
          <span class="filter-title">Uzrast</span>
          <div class="filter-options age-options">
            <button
              *ngFor="let age of ageOptions"
              type="button"
              class="filter-option"
              [ngClass]="{'active': activeAge === age}"
              (click)="changeAge(age)"
            >
              <span class="radio-indicator"></span>
              <span>{{formatAge(age)}}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="invitations-toolbar">
        <div class="media-tabs">
          <button
            *ngFor="let tab of mediaTabs"
            type="button"
            class="media-tab"
            [ngClass]="{'active': activeMediaType === tab.value}"
            (click)="changeMediaType(tab.value)"
          >
            <span>{{tab.label}}</span>
          </button>
        </div>

        <div class="media-actions">
          <button class="zc-btn zc-btn--gray" type="button" (click)="openMediaModal('video')">
            <span>Dodaj video</span>
          </button>
          <button class="zc-btn zc-btn--primary" type="button" (click)="openMediaModal('image')">
            <span>Dodaj slike</span>
          </button>
        </div>
      </div>

      <div class="media-grid-scroll" (scroll)="onMediaGridScroll($event)">
        <div *ngIf="isMediaLoading" class="media-state">
          <gr-loader></gr-loader>
        </div>

        <div *ngIf="!isMediaLoading && visibleMediaItems.length" class="media-grid">
          <div *ngFor="let item of visibleMediaItems" class="media-card">
            <div class="media-preview" [ngClass]="{'video-preview': item.type === 'video'}">
              <img *ngIf="item.fullPath && item.type === 'image'" [src]="item.fullPath" [alt]="item.name">
              <img *ngIf="item.type === 'video' && item.posterPath" [src]="item.posterPath" [alt]="item.name">
              <button
                *ngIf="item.type === 'video'"
                type="button"
                class="video-play-button"
                (click)="openVideoPreview(item)"
                [attr.aria-label]="'Pusti video ' + item.name"
              >
                <i class="fa-solid fa-play"></i>
              </button>
            </div>
            <span class="media-name">{{item.name}}</span>
          </div>
        </div>

        <div *ngIf="!isMediaLoading && !visibleMediaItems.length" class="media-state">
          <span>Nema dodatih stavki za izabrani filter.</span>
        </div>

        <div *ngIf="!isMediaLoading && isMediaLoadingMore" class="load-more-state">
          <span>Ucitavanje...</span>
        </div>

        <div *ngIf="!isMediaLoading && !isMediaLoadingMore && hasMoreItems" class="load-more-state">
          <span>Ucitaj jos...</span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="previewVideoItem" class="video-preview-modal-backdrop" (click)="closeVideoPreview()">
    <div class="video-preview-modal" (click)="$event.stopPropagation()">
      <div class="video-preview-modal-header">
        <span>{{previewVideoItem.name}}</span>
        <button type="button" (click)="closeVideoPreview()" aria-label="Zatvori preview">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <video
        *ngIf="previewVideoItem.fullPath"
        [src]="previewVideoItem.fullPath"
        controls
        autoplay
      ></video>
    </div>
  </div>
</div>

<gr-edit-invitation-modal
  *ngIf="isMediaModalOpen"
  [mediaType]="activeMediaType"
  [mediaItems]="modalMediaItems"
  [invitationId]="activeInvitationId"
  (closeModal)="closeMediaModal()"
  (confirmModal)="onConfirmMediaModal($event)"
></gr-edit-invitation-modal>
